import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Upload,
} from 'antd';
import styled from 'styled-components';
import { read, utils } from 'xlsx';
import { FileExcelOutlined, UploadOutlined } from '@ant-design/icons';
import { saveAs } from 'file-saver';
import { useState } from 'react';

import { checkPersonalPhoneNumber, checkRRN } from '../../util/utils';
import { VendorType } from '../../modules/vendors';

const StyledDiv = styled.div``;

interface VendorWorkerBulkUploadModalProps {
  visible: boolean;
  onCreate: (value: any) => void;
  onCancel: () => void;
}

function VendorWorkerBulkUploadModal({
  visible,
  onCreate,
  onCancel,
}: VendorWorkerBulkUploadModalProps) {
  const [form] = Form.useForm();
  const [isFileDownloading, setIsFileDownloading] = useState<boolean>(false);

  const beforeUpload = (file: any) => {
    const reader = new FileReader();
    reader.onload = async (e: any) => {
      const fileData = e.target.result;
      const wb = await read(fileData, { type: 'binary' });
      const sheetNames = await wb.SheetNames;
      const results: any = {
        data: [],
        errors: [],
      };

      for (let i = 0; i < sheetNames.length; i++) {
        const sheet = await wb.Sheets[sheetNames[i]];
        const sheetRows: any[] = await utils.sheet_to_json(sheet);
        for (const row of sheetRows) {
          const name = row['이름'] === undefined ? '' : `${row['이름']}`;

          const residentNumber =
            row['주민등록번호'] === undefined
              ? ''
              : `${row['주민등록번호']}`.replaceAll('-', '');
          const personalPhoneNumber =
            row['휴대전화번호'] === undefined ? '' : `${row['휴대전화번호']}`;
          const address = row['주소'] === undefined ? '' : `${row['주소']}`;
          const jobLevel =
            row['급여수준(기공/조공)'] === undefined
              ? ''
              : `${row['급여수준(기공/조공)']}`;
          const wageForm =
            row['급여방식(일당/프리랜서)'] === undefined
              ? ''
              : `${row['급여방식(일당/프리랜서)']}`;
          const bankName =
            row['은행명'] === undefined ? '' : `${row['은행명']}`;
          const accountHolder =
            row['예금주'] === undefined ? '' : `${row['예금주']}`;
          const accountNumber =
            row['계좌번호'] === undefined ? '' : `${row['계좌번호']}`;

          // const residentNumber = `${row['주민등록번호']}`;
          // const personalPhoneNumber = `${row['휴대전화번호']}`;
          // const address = `${row['주소']}`;
          // const jobLevel = `${row['급여수준(기공/조공)']}`;
          // const wageForm = `${row['급여방식(일당/프리랜서)']}`;
          // const bankName = `${row['은행명']}`;
          // const accountHolder = `${row['예금주']}`;
          // const accountNumber = `${row['계좌번호']}`;

          results.data.push({
            type: VendorType.WORKER,
            application: {
              general: {
                name: name ?? '',
                residentNumber: residentNumber ?? '',
                personalPhoneNumber: personalPhoneNumber ?? '',
                address: address ?? '',
                jobLevel: jobLevel ?? '',
                wageForm: wageForm ?? '',
                // jobLevel:
                //   jobLevel === '기공' ? '1' : jobLevel === '조공' ? '2' : '',
                // wageForm:
                //   wageForm === '일당'
                //     ? '1'
                //     : wageForm === '프리랜서'
                //     ? '2'
                //     : '',
              },
              accountInfo: {
                bankName: bankName ?? '',
                accountHolder: accountHolder ?? '',
                accountNumber: accountNumber ?? '',
              },
            },
          });
        }
      }

      // setVendorList(results.data);
      form.setFieldsValue({ vendors: results.data });

      // _createVendors(results.data);
      console.log(results.data);
    };
    reader.readAsBinaryString(file);
    return false;
  };

  return (
    <StyledDiv>
      <Modal
        open={visible}
        width={1400}
        title="작업자 엑셀 일괄등록"
        footer={null}
        onCancel={onCancel}
      >
        <>
          <Form
            form={form}
            name="dynamic_form_complex"
            onFinish={onCreate}
            autoComplete="off"
            layout={'vertical'}
            initialValues={{}}
          >
            <Form.Item>
              <Row>
                <Col>
                  <Button
                    size="middle"
                    // target="_blank"
                    // onClick={() => {
                    //   window.open(
                    //     'https://docs.google.com/spreadsheets/d/1xjNEbtcdcI3M1I5atTWQfcH_8LgpQ5Y2/edit?usp=drive_link&ouid=111943059962967290277&rtpof=true&sd=true',
                    //     '_blank',
                    //     'noopener, noreferrer',
                    //   );
                    // }}
                    loading={isFileDownloading}
                    // disabled={isFileDownloading}
                    onClick={() => {
                      setIsFileDownloading(true);
                      console.log('true');
                      saveAs(
                        'https://constlink-sample-files-bucket.s3.ap-northeast-2.amazonaws.com/%E1%84%8C%E1%85%A1%E1%86%A8%E1%84%8B%E1%85%A5%E1%86%B8%E1%84%8C%E1%85%A1%2B%E1%84%8B%E1%85%B5%E1%86%AF%E1%84%80%E1%85%AA%E1%86%AF%E1%84%83%E1%85%B3%E1%86%BC%E1%84%85%E1%85%A9%E1%86%A8%2B%E1%84%8B%E1%85%A3%E1%86%BC%E1%84%89%E1%85%B5%E1%86%A8.xlsx',
                        // 'https://constlink-sample-files-bucket.s3.ap-northeast-2.amazonaws.com/%E1%84%8C%E1%85%A1%E1%86%A8%E1%84%8B%E1%85%A5%E1%86%B8%E1%84%8C%E1%85%A1+%E1%84%8B%E1%85%B5%E1%86%AF%E1%84%80%E1%85%AA%E1%86%AF%E1%84%83%E1%85%B3%E1%86%BC%E1%84%85%E1%85%A9%E1%86%A8+%E1%84%8B%E1%85%A3%E1%86%BC%E1%84%89%E1%85%B5%E1%86%A8.xlsx',
                        // 'https://docs.google.com/spreadsheets/d/1xjNEbtcdcI3M1I5atTWQfcH_8LgpQ5Y2/edit?usp=drive_link&ouid=111943059962967290277&rtpof=true&sd=true',
                        // "https://docs.google.com/spreadsheets/d/e/2PACX-1vS0yu_lA9DZgte-YAOujEWMaLXoWtbLtEeOB47ywQcK29ccyyVq8c43WGHCAiZgSQ/pub?output=xlsx"
                        // '작업자_일괄등록_양식.xlsx',
                      );
                      console.log('false');
                      setIsFileDownloading(false);
                    }}
                  >
                    <FileExcelOutlined rev={undefined} />
                    양식파일 다운로드
                  </Button>
                  {/* <Link href="https://docs.google.com/spreadsheets/d/1xjNEbtcdcI3M1I5atTWQfcH_8LgpQ5Y2/edit?usp=drive_link&ouid=111943059962967290277&rtpof=true&sd=true">
                    <FileExcelOutlined rev={undefined} />
                    양식파일 다운로드
                  </Link> */}
                </Col>
                <Col style={{ marginLeft: '20px' }}>
                  <Upload
                    accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    showUploadList={false}
                    beforeUpload={beforeUpload}
                  >
                    <Button size="middle">
                      <UploadOutlined rev={undefined} />
                      파일열기
                    </Button>
                  </Upload>
                </Col>
                <Col style={{ marginLeft: '20px' }}>
                  <Button type="primary" size="middle" htmlType="submit">
                    저장
                  </Button>
                </Col>
              </Row>
            </Form.Item>
            <Divider>업로드 데이터</Divider>
            <Form.List name="vendors">
              {(fields) => (
                <>
                  {fields.map((field) => (
                    <>
                      <Space key={field.key + '00'} align="baseline">
                        <Form.Item
                          {...field}
                          key={field.key + '00'}
                          label="이름"
                          name={[field.name, 'application', 'general', 'name']}
                          rules={[{ required: true }]}
                        >
                          <Input />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          key={field.key + '01'}
                          label="주민등록번호"
                          name={[
                            field.name,
                            'application',
                            'general',
                            'residentNumber',
                          ]}
                          rules={[
                            {
                              validator: (_, value) => checkRRN(value),
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          key={field.key + '02'}
                          name={[
                            field.name,
                            'application',
                            'general',
                            'personalPhoneNumber',
                          ]}
                          label="휴대전화번호"
                          rules={[
                            {
                              validator: (_, value) =>
                                checkPersonalPhoneNumber(value),
                            },
                          ]}
                        >
                          <Input placeholder="예) 3493901068" />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          key={field.key + '03'}
                          name={[
                            field.name,
                            'application',
                            'general',
                            'address',
                          ]}
                          label="주소"
                        >
                          <Input placeholder="예) 0311234567" />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          key={field.key + '04'}
                          name={[
                            field.name,
                            'application',
                            'general',
                            'jobLevel',
                          ]}
                          label="급여수준(기공/조공)"
                        >
                          <Input placeholder="청주시 청원구 오창읍 오창중앙로 123-12" />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          key={field.key + '05'}
                          name={[
                            field.name,
                            'application',
                            'general',
                            'wageForm',
                          ]}
                          label="급여방식(일당/프리랜서)"
                        >
                          <Input type="text" placeholder="예) 0311234567" />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          key={field.key + '06'}
                          name={[
                            field.name,
                            'application',
                            'accountInfo',
                            'bankName',
                          ]}
                          label="은행명"
                        >
                          <Input placeholder="예) 국민은행" />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          key={field.key + '07'}
                          name={[
                            field.name,
                            'application',
                            'accountInfo',
                            'accountHolder',
                          ]}
                          label="예금주"
                        >
                          <Input placeholder="예) 홍길동" />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          key={field.key + '08'}
                          name={[
                            field.name,
                            'application',
                            'accountInfo',
                            'accountNumber',
                          ]}
                          label="계좌번호"
                        >
                          <Input placeholder="예) 74391013412345" />
                        </Form.Item>
                      </Space>
                      <Divider />
                    </>
                  ))}
                </>
              )}
            </Form.List>
          </Form>
        </>
      </Modal>
    </StyledDiv>
  );
}

export default VendorWorkerBulkUploadModal;
